/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Action_Create_PostInputs */

const en_action_create_post = /** @type {(inputs: Action_Create_PostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Publish Update`)
};

const es_action_create_post = /** @type {(inputs: Action_Create_PostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Publicar Actualización`)
};

const fr_action_create_post = /** @type {(inputs: Action_Create_PostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Publier la mise à jour`)
};

const de_action_create_post = /** @type {(inputs: Action_Create_PostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Update veröffentlichen`)
};

const id_action_create_post = /** @type {(inputs: Action_Create_PostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terbitkan Pembaruan`)
};

/** @type {(inputs: Action_Create_PostInputs) => LocalizedString} */
const ja_action_create_post = en_action_create_post;

/** @type {(inputs: Action_Create_PostInputs) => LocalizedString} */
const zh_action_create_post = en_action_create_post;

/** @type {(inputs: Action_Create_PostInputs) => LocalizedString} */
const ar_action_create_post = en_action_create_post;

/** @type {(inputs: Action_Create_PostInputs) => LocalizedString} */
const it_action_create_post = en_action_create_post;

/** @type {(inputs: Action_Create_PostInputs) => LocalizedString} */
const ru_action_create_post = en_action_create_post;

/** @type {(inputs: Action_Create_PostInputs) => LocalizedString} */
const pt_action_create_post = en_action_create_post;

/** @type {(inputs: Action_Create_PostInputs) => LocalizedString} */
const ko_action_create_post = en_action_create_post;

/**
* | output |
* | --- |
* | "Publish Update" |
*
* @param {Action_Create_PostInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const action_create_post = /** @type {((inputs?: Action_Create_PostInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Action_Create_PostInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_action_create_post(inputs)
	if (locale === "es") return es_action_create_post(inputs)
	if (locale === "fr") return fr_action_create_post(inputs)
	if (locale === "de") return de_action_create_post(inputs)
	if (locale === "ja") return ja_action_create_post(inputs)
	if (locale === "zh") return zh_action_create_post(inputs)
	if (locale === "ar") return ar_action_create_post(inputs)
	if (locale === "id") return id_action_create_post(inputs)
	if (locale === "it") return it_action_create_post(inputs)
	if (locale === "ru") return ru_action_create_post(inputs)
	if (locale === "pt") return pt_action_create_post(inputs)
	return ko_action_create_post(inputs)
});